import React, {useEffect, useRef, useState} from 'react';
import {TextField, Tooltip} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {IoDocumentsSharp} from "react-icons/io5";
import LoaderCustomFixed from "../../../components/ConfirmationModal/LoaderCustomFixed";
import "./SplitButton.css";
import {FaExclamationCircle} from "react-icons/fa";
import {AiOutlineClose} from "react-icons/ai";

const SplitButton = ({options, renderDocumentComponent, buttonLabel, buttonType = 1, isDisabled}) => {
    const [isOpen, setIsOpen] = useState(false);
    const wrapperRef = useRef(null);
    const dropdownRef = useRef(null);
    const [searchTerm, setSearchTerm] = useState('');


    const handleClick = () => {
        setIsOpen((prev) => !prev);
    };

    const handleClickOutside = (event) => {
        const isScrollbarClick =
            event.target === document.body ||
            event.target === document.documentElement;

        if (isScrollbarClick) return;

        if (
            wrapperRef.current &&
            !wrapperRef.current.contains(event.target) &&
            dropdownRef.current &&
            !dropdownRef.current.contains(event.target) &&
            !event.target.closest('.MuiMenuItem-root') &&
            !event.target.closest('.MuiList-root') &&
            !event.target.closest('.MuiList-padding') &&
            !event.target.closest('.PrivateSwitchBase-input') &&
            !event.target.closest('.MuiMenu-list') &&
            !event.target.closest('.css-6hp17o-MuiList-root-MuiMenu-list') &&
            !event.target.closest('.notification-popup') &&
            !event.target.closest('.jodit') &&
            !event.target.closest('.MuiBackdrop-root') &&
            !Array.from(event.target.classList).some(className =>
                className.toLowerCase().includes('mui')
            )
        ) {
            setIsOpen(false);
        }
    };


    const filteredOptions = options.filter((option) =>
        option.name.toLowerCase().includes(searchTerm.toLowerCase())
    );


    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div ref={wrapperRef} >
            {buttonType === 1 && (
                <button
                    disabled={isDisabled}
                    onClick={handleClick}
                    className="document-buttonn"
                >
                    <span className="button-label">{buttonLabel}</span>
                    <div className={isDisabled ? "button-icon-container-disabled" : "button-icon-container"}>
                        <span className="button-icon"><ArrowDropDownIcon/></span>
                    </div>
                </button>
            )}
            {buttonType === 2 && (
                <Tooltip title="დოკუმენტის შექმნა">
                    <div>
                        <IoDocumentsSharp
                            onClick={handleClick}
                            className="send-for-visage-doc-button"
                        >
                            <span className="button-label">{buttonLabel}</span>
                            <div className="button-icon-container">
                                <span className="button-icon"><ArrowDropDownIcon/></span>
                            </div>
                        </IoDocumentsSharp>
                    </div>
                </Tooltip>
            )}
            {buttonType === 3 && (
                <button
                    onClick={handleClick}
                    disabled={isDisabled}
                    className="document-buttonn-cancel"
                >
                    <span className="button-label">{buttonLabel}</span>
                </button>
            )}

            {isOpen && (
                <div
                    ref={dropdownRef}
                    style={{right: buttonType === 2 ? 70 : undefined}}
                    className="dropdown-menu custom-scrollbar"
                    onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
                >
                    <div className="search-container">
                        <TextField
                            variant="outlined"
                            label="დოკუმენტის ტიპი"
                            fullWidth
                            className="search-field"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            size="small"
                            InputProps={{
                                endAdornment: searchTerm && (
                                    <AiOutlineClose
                                        className="clear-icon"
                                        onClick={() => setSearchTerm('')}
                                    />
                                )
                            }}
                        />
                    </div>

                    {filteredOptions.length === 0 ? (
                        <div className="no-options">
                            {options.length === 0 ? (
                                <LoaderCustomFixed/>
                            ) : (
                                <>
                                    <FaExclamationCircle className="no-options-icon"/>
                                    <span>არაფერი მოიძებნა!</span>
                                </>
                            )}
                        </div>
                    ) : (
                        filteredOptions.map((option) => (
                            <div
                                key={option.id}
                                style={{width: "100%"}}
                                onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside nested component
                            >
                                {renderDocumentComponent(option, setIsOpen)}
                            </div>
                        ))
                    )}
                </div>
            )}
        </div>
    );
};

export default SplitButton;
